import "./button.css";

function Buttons() {
  return (
    <div className="container button-container">
      <a target="_black" rel='noreferrer' href="https://drive.google.com/file/d/1b1qpkaw3z0Lo2OhcDKDxzSJhs9G5p6nI/view?usp=sharing" className="btn pri bg-black">
        Download Resume
      </a>
      <a href="#contact" className="btn sec">
        Get in Touch
      </a>
    </div>
  );
}

export default Buttons;
